// extracted by mini-css-extract-plugin
export default {"content":"QuestionnaireDetails_content__ADuPD"};